"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  name: 'DetailIssue',
  data: function data() {
    return {
      dataAnalysisList: [],
      isShow: false,
      addData: {
        downMonitorNum: '',
        downDataParser: '',
        isDownModelConvert: '',
        isDownAdditionalValue: 'false',
        downDefaultAdditionalValue: '',
        isConvert: 'false',
        isSubjoin: 'false',
        downModelValue: '' },

      rules: {} };


  },
  mounted: function mounted() {
    var self = this;
    self.handleGetData();
  },
  methods: {
    handleGetData: function handleGetData() {
      this.dataAnalysisList.push({ name: '无需解析', value: 'empty_parser' });
      this.dataAnalysisList.push({ name: '正常数值解析', value: 'number_parser' });
      this.dataAnalysisList.push({ name: '高低位数值解析', value: 'reverse_number_parser' });
      this.dataAnalysisList.push({ name: '十六进制解析', value: 'hexstring_parser' });
      this.dataAnalysisList.push({ name: '时间解析', value: 'time_parser' });
      this.dataAnalysisList.push({ name: '位解析', value: 'bit_parser' });
      this.dataAnalysisList.push({ name: '字符串解析', value: 'string_parser' });
      this.dataAnalysisList.push({ name: '多个位解析', value: 'multi_bit_parser' });
      this.dataAnalysisList.push({ name: '一位小数解析', value: 'decimal_parser' });
    },
    handleChangeSubjoin: function handleChangeSubjoin() {
      if (this.addData.isDownAdditionalValue === 'true') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    handleGetIssueData: function handleGetIssueData(data) {
      this.addData = data;
      console.log('issue', data);
    },
    handleGetResult: function handleGetResult() {
      return this.addData;
    },
    handleChangeFunctionShow: function handleChangeFunctionShow() {
      this.$emit('handleChangeFunctionShow');
    },
    handleChangeConvert: function handleChangeConvert() {
    } } };exports.default = _default;